<script>
  import '@awesome.me/webawesome-pro/dist/components/dropdown/dropdown.js';
  import '@awesome.me/webawesome-pro/dist/components/dropdown-item/dropdown-item.js';
  import '@awesome.me/webawesome-pro/dist/components/divider/divider.js';
  import '@awesome.me/webawesome-pro/dist/components/avatar/avatar.js';

  import { authState, logout, hasPermission } from '#state/auth';

  let avatarUrl = $derived(authState.profile?.picture);

  let avatarInitials = $derived(
    authState.profile?.given_name !== undefined &&
    authState.profile?.family_name !== undefined
      ? authState.profile.given_name.charAt(0) + authState.profile.family_name.charAt(0)
      : '?'
  );

  let canAddAsset = $derived(hasPermission('access:all_apps'));

  // --- DEBUGGING EFFECT ---
  $effect(() => {
    console.log('[ProfileButton Debug] State Evaluation:');
    console.log('  -> authState.profile object:', $state.snapshot(authState.profile));
    console.log('  -> Derived avatarUrl:', avatarUrl);
    console.log('  -> Derived avatarInitials:', avatarInitials);
  });

  function handleLogout() {
    logout();
  }

  function handleAddAsset() {
    console.log('Add new asset clicked - stub');
  }
</script>

<wa-dropdown>
  <wa-avatar
    slot="trigger"
    image={avatarUrl}
    initials={avatarInitials}
    label="User Profile"
    class="profile-avatar"
  ></wa-avatar>

  <wa-dropdown-item onclick={handleAddAsset} disabled={canAddAsset === false}>Add new asset</wa-dropdown-item>
  <wa-divider></wa-divider>
  <wa-dropdown-item onclick={handleLogout}>Logout</wa-dropdown-item>
</wa-dropdown>

<style>
  .profile-avatar {
    cursor: pointer;
    transition: opacity 0.2s ease;
  }

  .profile-avatar:hover {
    opacity: 0.85;
  }
</style>